var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconScheduling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14570_644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5312 23.25C19.3099 23.25 21.5625 20.8995 21.5625 18C21.5625 15.1005 19.3099 12.75 16.5312 12.75C13.7526 12.75 11.5 15.1005 11.5 18C11.5 20.8995 13.7526 23.25 16.5312 23.25Z",
    stroke: "#313335",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5312 15.75V18H18.6875",
    stroke: "#313335",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46875 0.75V3.75",
    stroke: "#313335",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5312 0.75V3.75",
    stroke: "#313335",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2812 8.25H0.71875",
    stroke: "#313335",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.625 21.75H2.875C1.68403 21.75 0.71875 20.7427 0.71875 19.5V6C0.71875 4.75725 1.68403 3.75 2.875 3.75H20.125C21.316 3.75 22.2812 4.75725 22.2812 6V11.25",
    stroke: "#313335",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14570_644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScheduling);
export default __webpack_public_path__ + "static/media/icon_scheduling.d20d49cf.svg";
export { ForwardRef as ReactComponent };